//Import for Webpack
import './DefaultSlideshowModule.scss';

import CoreSlideshowModule from "core/modules/CoreSlideshowModule/CoreSlideshowModule";

export default class DefaultSlideshowModule extends CoreSlideshowModule {

}